import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { DeploymentAutocompleteSelect } from "components/autocomplete";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import { injectIntl } from "react-intl";
import styles from "./search-form/styles.css.js";
import withStyles from "components/with-styles";

const SearchForm = ({ intl, classes, deploymentId, setDeploymentId, contractName, setContractName }) => (
  <DataGrid>
    <DataGridItem big>
      <DeploymentAutocompleteSelect
        id="deploymentIdFilter"
        name="deploymentIdFilter"
        placeholder={intl.formatMessage({ id: "app.page.contract.search.deployment" })}
        label={intl.formatMessage({ id: "contract.deployment" })}
        value={deploymentId}
        onChange={name => value => setDeploymentId(value)}
      />
    </DataGridItem>
    <DataGridItem big>
      <div>
        <InputLabel className={classes.select_label} htmlFor="contractNameFilter">
          {intl.formatMessage({ id: "common.name" })}
        </InputLabel>
        <TextField
          id="contractNameFilter"
          name="contractNameFilter"
          fullWidth
          onChange={ev => setContractName(ev.target.value)}
          value={contractName}
          placeholder={intl.formatMessage({ id: "app.page.contract.search.name" })}
        />
      </div>
    </DataGridItem>
  </DataGrid>
);

SearchForm.propTypes = {
  /**
   * Deployment Id de la búsqueda
   */
  deploymentId: PropTypes.string,
  /**
   * Setea el deployment Id de la búsqueda
   */
  setDeploymentId: PropTypes.func,
  /**
   * Contract name de la búsqueda
   */
  contractName: PropTypes.string,
  /**
   * Setea el contract name de la búsqueda
   */
  setContractName: PropTypes.func,
};

export default injectIntl(withStyles(styles)(SearchForm));
